// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"a6e7c252","312":"82b00154","776":"9e5469c1","853":"3c7f6c70"}[chunkId] + ".chunk.js";
};